import { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { UserLink, UserAvatar } from "@/components/UserBits";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function VideoViewers({ postId }) {
  const [d, setD] = useState(null);
  const load = () => api.get(`/feed/posts/${postId}/video-viewers`).then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, [postId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <button data-testid={`video-viewers-${postId}`} className="mt-2 inline-flex items-center gap-1.5 px-3 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-xs font-bold text-slate-600 transition-colors">
          <Eye className="w-3.5 h-3.5" /> {d.count === 1 ? "1 hat es komplett geschaut" : `${d.count} haben es komplett geschaut`}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" collisionPadding={12} className="w-72 max-h-80 overflow-y-auto rounded-2xl p-3" data-testid={`video-viewers-list-${postId}`}>
        <p className="text-xs font-extrabold uppercase tracking-wider text-slate-400 mb-2">Komplett angeschaut · nur für Admins</p>
        {d.users.length === 0 ? <p className="text-sm text-slate-500">Noch niemand – teilt das Video doch mal 😊</p> : (
          <ul className="space-y-2">{d.users.map((u) => (
            <li key={u.user_id} className="flex items-center gap-2 min-w-0">
              <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-8 h-8" />
              <div className="min-w-0"><UserLink id={u.user_id} className="text-sm font-bold truncate block">{u.name}</UserLink><p className="text-[11px] text-slate-400">{fmtDate(u.at)}</p></div>
            </li>))}
          </ul>)}
      </PopoverContent>
    </Popover>
  );
}
